<template>
  <a-drawer width="60%" :visible="open" :title="formTitle" @cancel="onClose" @close="onClose" :destroyOnClose="true">
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-divider orientation="left"><b>{{ $t('银行支行.基础信息') }}</b></a-divider>

      <a-form-model-item :label="$t('银行支行.联行号')" prop="code">
        <a-input v-model="form.code" :maxLength="32" :placeholder="$t('银行支行.请输入联行号')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('银行支行.清算行号')" prop="clearingCode">
        <a-input v-model="form.clearingCode" :maxLength="32" :placeholder="$t('银行支行.请输入清算行号')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('银行支行.银行全名')" prop="name">
        <a-input v-model="form.name" :maxLength="255" :placeholder="$t('银行支行.请输入银行全名')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('银行支行.银行简称')" prop="bankAlias">
        <a-input v-model="form.bankAlias" :maxLength="64" :placeholder="$t('银行支行.请输入银行简称')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('银行支行.银行名称')" prop="bankName">
        <a-input v-model="form.bankName" :maxLength="64" :placeholder="$t('银行支行.请输入银行名称')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('银行支行.银行编码')" prop="bankCode">
        <a-input v-model="form.bankCode" :maxLength="64" :placeholder="$t('银行支行.请输入银行编码')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('银行支行.图标')" prop="bankIcon">
        <a-select v-model="form.bankIcon" :placeholder="$t('银行支行.请选择图标')" allow-clear>
          <a-select-option v-for="(item, index) in bankIconDict" :key="index" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-divider orientation="left"><b>{{ $t('银行支行.地区信息') }}</b></a-divider>

      <a-form-model-item :label="$t('银行支行.城市名称')" prop="cityName">
        <a-input v-model="form.cityName" :maxLength="64" :placeholder="$t('银行支行.请输入城市名称')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('银行支行.省份名称')" prop="provinceName">
        <a-select v-model="form.provinceName" :placeholder="$t('银行支行.请选择省份名称')" allow-clear>
          <a-select-option v-for="(item, index) in provinceDict" :key="index" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item :label="$t('通用.文本.备注')" prop="remark">
        <a-textarea v-model="form.remark" :rows="3" :maxLength="500" :placeholder="$t('通用.输入.请输入') + $t('通用.文本.备注')" />
      </a-form-model-item>
    </a-form-model>

    <div class="bottom-control">
      <a-space>
        <a-button type="primary" :loading="submitLoading" @click="submitForm">{{ $t('通用.按钮.保存') }}</a-button>
        <a-button @click="onClose">{{ $t('通用.按钮.取消') }}</a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>
import { updateBankBranch, listProvinceDict, listBankIconDict } from '@/api/bank/bankBranch'

export default {
  name: 'BankBranchCreateForm',
  data() {
    return {
      open: false,
      formTitle: '',
      submitLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      provinceDict: [],
      bankIconDict: [],
      form: {},
      rules: {
        code: [{ required: true, message: this.$t('银行支行.联行号') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        name: [{ required: true, message: this.$t('银行支行.银行全名') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        bankAlias: [{ required: true, message: this.$t('银行支行.银行简称') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        bankCode: [{ required: true, message: this.$t('银行支行.银行编码') + this.$t('通用.文本.不能为空'), trigger: 'blur' }]
      }
    }
  },
  methods: {
    getBaseForm() {
      return {
        id: undefined,
        code: undefined,
        clearingCode: undefined,
        name: undefined,
        bankAlias: undefined,
        bankName: undefined,
        bankCode: undefined,
        bankIcon: undefined,
        cityName: undefined,
        cityCode: undefined,
        provinceCode: undefined,
        provinceName: undefined,
        remark: undefined
      }
    },
    handleUpdate(record) {
      this.formTitle = this.$t('通用.按钮.修改')
      this.form = this.getBaseForm()
      // 详情接口不要求，直接用列表中的数据回填
      this.form = { ...this.getBaseForm(), ...record }
      this.open = true
    },
    onClose() {
      this.open = false
    },
    loadDicts() {
      if (this.provinceDict.length === 0) {
        listProvinceDict().then((response) => {
          this.provinceDict = response.data || []
        })
      }
      if (this.bankIconDict.length === 0) {
        listBankIconDict().then((response) => {
          this.bankIconDict = response.data || []
        })
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        this.submitLoading = true
        updateBankBranch(this.form)
          .then(() => {
            this.$message.success(this.$t('通用.文本.修改成功'))
            this.onClose()
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    }
  }
}
</script>

<style scoped>
.bottom-control {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
</style>